/**
 * Modal dimension constants - tiered system for consistent sizing
 *
 * SMALL (360px): Alerts, confirmations, error dialogs
 * MEDIUM (480px): Forms, inputs, address entry
 * LARGE (600px): Content-heavy modals (coupons, detailed info)
 * XLARGE (560px): Horizontal product-tile dialogs (catalogue Add-to-Cart),
 *   sized to fit 3 × 150px tiles with margins/padding so the dialog stays
 *   square-ish even when only one product is shown.
 */

export const MODAL_MAX_WIDTH = {
  SMALL: 360,
  MEDIUM: 480,
  LARGE: 600,
  XLARGE: 560,
} as const;

export const MODAL_MIN_WIDTH = 320;
export const MODAL_WIDTH_PERCENTAGE = 0.9;
export const MODAL_MAX_HEIGHT_PERCENTAGE = 0.9;

export type ModalSize = 'small' | 'medium' | 'large' | 'xlarge';

export const MODAL_SIZE_MAP: Record<ModalSize, number> = {
  small: MODAL_MAX_WIDTH.SMALL,
  medium: MODAL_MAX_WIDTH.MEDIUM,
  large: MODAL_MAX_WIDTH.LARGE,
  xlarge: MODAL_MAX_WIDTH.XLARGE,
};
